import { render, staticRenderFns } from "./ViceBannerTable.vue?vue&type=template&id=89d24542&scoped=true&"
import script from "./ViceBannerTable.vue?vue&type=script&lang=ts&"
export * from "./ViceBannerTable.vue?vue&type=script&lang=ts&"
import style0 from "./ViceBannerTable.vue?vue&type=style&index=0&id=89d24542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d24542",
  null
  
)

export default component.exports